<template>
 <span
 @click.stop="templet.is_jump({href:`#/article?id=${item.id}&tag_id=${item.tag_ids}`,target:fromTag === 'search' ? '_blank' : pc_infor.target})"
      class="basic_button height_fill" :style="{
        width:  listArr.moduleStyle == 4 ? 'auto' : '100%'
      }">
        <div class="buttonContent" 
      :class="pc_infor.button_text.styleType"
      :style="{
        height: '100%',
        '--borderSeColor': buttonStyle.borderSeColor,
        '--borderColor': buttonStyle.borderColor,
        '--backgroundColor': buttonStyle.backgroundColor,
        '--backgroundSeColor': buttonStyle.backgroundSeColor,
        '--fontColor': buttonStyle.fontColor,
        '--fontSeColor': buttonStyle.fontSeColor,
        borderStyle: buttonStyle.borderStyle,
        borderWidth: buttonStyle.borderWidth + 'px',
        borderRadius:  buttonStyle.borderRadius + 'px'
      }">
        <div class="bothHeight">
            <span class="btnLink">
              <div class="edit-div btnWords" :style="{
              fontSize: Math.min(pc_infor.font[pc_infor.font.radio_val].fontSize - 4, 20) + 'px',
              fontFamily: pc_infor.font[pc_infor.font.radio_val].fontFamily
            }">{{pc_infor.button_text.value}}</div>
              <span class="after"></span>
            </span>
          </div>
      </div>
 </span>
</template>

<script>
import i18n from '../../../language/index'

import {detail_button_style} from '@/base/base'

export default {
  name: "detail_button",
  data() {
    return {
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    fromTag: { // 是否为全局搜索挂件
      type: String,
      default: ''
    }
  },
  watch: {},
  methods: {
  },
  computed: {
    listArr() {
      return this.module.data.listArr
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor
    },
    buttonStyle(){
      let styleType= this.pc_infor.button_text.styleType
      const fontSize = this.pc_infor.font[this.pc_infor.font.radio_val].fontSize || 16
      const theme_color = this.$store.state.myRender.common.theme_color
      return detail_button_style(styleType,theme_color,fontSize)
    },
    borderColor() {
      return this.buttonStyle.borderColor;
    },
    borderSeColor() {
      return this.buttonStyle.borderSeColor;
    },
    backgroundColor() {
      return this.buttonStyle.backgroundColor;
    },
    backgroundSeColor() {
      return this.buttonStyle.backgroundSeColor;
    },
    fontColor() {
      return this.buttonStyle.fontColor;
    },
    fontSeColor() {
      return this.buttonStyle.fontSeColor;
    },
  },
  components: {},
  created() {
  },
  mounted() {
  }
};
</script>

<style scoped lang="scss">
.basic_button {
  display: inline-block;
  .buttonContent {
    transition: all 0.6s;
    background: var(--backgroundColor);
    z-index: 10;
  }
  .edit-div {
    min-height: 100%;
    padding: 8px 20px;
  }
  .btnLink {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    text-align: center;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-transform-style: preserve-3d;
    -moz-transform-style: preserve-3d;
    transform-style: preserve-3d;
    .linkPart {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .after {
      pointer-events: none;
    }
  }
}
.basic_button .btnLink  .btnWords {
  height: unset;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  min-width: 10px;
  overflow: hidden;
  display: block;
  width: 100%;
  position: relative;
  outline: 0;  
}
.basic_button .buttonContent.type_0 {
  border-radius: 4px;
  border-color: var(--borderColor);
  color: var(--fontColor);
  position: relative;
  background: var(--backgroundColor);
  .after {
    display: block;
    transition: all 0.6s;
    width: 100%;
    height: 0;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    padding-top: 100%;
    position: absolute;
    z-index: 10;
    transform: translateX(-50%) translateY(-50%);
  }
}

.basic_button .buttonContent.type_0:hover {
  .after {
    -webkit-animation: button_style_0_anim 0.75s;
    -moz-animation: button_style_0_anim 0.75s;
    -o-animation: button_style_0_anim 0.75s;
    animation: button_style_0_anim 0.75s;
    z-index: 11;
  }
}

.basic_button .buttonContent.type_0:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_1 {
  border-radius: 20px;
  color: var(--fontColor);
  position: relative;
  background: var(--backgroundColor);
  border: 1px solid var(--borderColor);
}
.basic_button .buttonContent.type_1:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_2 {
  position: relative;
  border-radius: 4px;
  color: var(--fontColor);
  border-color: var(--borderColor);
}

.basic_button .buttonContent.type_2:hover { 
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_3 {
  position: relative;
  border-radius: 20px;
  color: var(--fontColor);
  background: var(--backgroundColor);
  border-width: 1px;
  border-style: solid;
  border-color: var(--borderColor);
}
.basic_button .buttonContent.type_3:hover {
  color: var(--fontSeColor);
  border: 1px solid var(--borderSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_4 {
  position: relative;
  background: var(--backgroundColor);
  color: var(--fontColor);
  border: 1px solid var(--borderColor);
}
.basic_button .buttonContent.type_4:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
  border: 1px solid var(--borderSeColor);
}
.basic_button .buttonContent.type_5 {
  position: relative;
  background: var(--backgroundColor);
  color: var(--fontColor);
  border: 1px solid var(--borderColor);
  position: relative;
  .btnWords {
    position: relative;
  }
  .after {
    display: block;
    width: 0%;
    height: 100%;
    background: var(--backgroundColor);
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: all 0.3s;
    z-index: -1;
  }
}
.basic_button .buttonContent.type_5:hover {
  color: var(--fontSeColor);
  .btnWords {
    color: var(--fontSeColor);
  }
  .after {
    background: var(--backgroundSeColor);
    border: 1px solid var(--borderSeColor);
    opacity: 1;
    width: 100%;
  }
}
.bothHeight {
  height: 100%;
}

.basic_button .buttonContent:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
  border: 1px solid var(--borderSeColor);
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_article_list/components/detail_button.vue